<p>
  Users
</p>
<button routerLink="/management/user-create">Add User</button>

<p-table selectionMode="single" [value]="users">
  <ng-template pTemplate="header">
      <tr>
          <th [style]="{width: '80px'}">
              ID
          </th>
          <th>
              Name
          </th>
          <th>
              Role
          </th>
      </tr>
  </ng-template>
  <ng-template pTemplate="body" let-user>
      <tr [pSelectableRow]="user">
          <td>
              {{user.id}}
          </td>
          <td class="name-box">
              <a routerLink="/management/user-edit/{{user.id}}">
                  {{user.name}}
              </a>
          </td>
          <td>
            <p *ngIf="isAdmin(user)">
              admin
            </p>
            <p *ngIf="!isAdmin(user)">
              {{user.roles[0].name}}
            </p>
          </td>
      </tr>
  </ng-template>
</p-table>
